import trustpilotIcon from 'images/BenefitsIcons/trustPilot-white.svg';
import googleIcon from 'images/BenefitsIcons/google-white.svg';

export const trustpilot = 'trustpilot';

export const google = 'google';

export const sourceName = {
  testimonials_url_google: google,
  testimonials_url_trustpilot: trustpilot
};

export const imageSource = {
  google: {
    src: googleIcon,
    title: google,
    alt: google
  },
  trustpilot: {
    src: trustpilotIcon,
    title: trustpilot,
    alt: trustpilot
  }
};